import { Maybe, Media } from 'graphql.generated';
import {
    AdditionalLink,
    AdditionalLinkDefaults
} from './AdditionalLinks.types';

export const mapLinksToCTAs = (
    links: Maybe<Array<Media>>
): Array<AdditionalLink> | undefined => {
    if (!links || links.length < 1) {
        return;
    }

    const ctas: Array<AdditionalLink> = [];
    links.forEach(({ caption, original, type }) => {
        let label = caption;

        if (
            (!label || label.length < 1) &&
            type &&
            AdditionalLinkDefaults[type]
        ) {
            label = AdditionalLinkDefaults[type];
        }

        if (label && original) {
            ctas.push({
                href: original,
                label
            });
        }
    });
    return ctas;
};
